import { createFileRoute, redirect } from "@tanstack/react-router";
import { loginSearchSchema } from "./-lib/search-schema";



export const Route = createFileRoute("/(auth)/login/")({
  head: () => ({
    meta: [{ title: "登录 · imiker CRM" }],
  }),
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({ to: "/" });
    }
  },
  validateSearch: loginSearchSchema
});
